// extracted by mini-css-extract-plugin
export var active = "DropDownMenu-module--active--b81e5";
export var bottomCloudContainer = "DropDownMenu-module--bottomCloudContainer--8ec6b";
export var buttonContainer = "DropDownMenu-module--buttonContainer--c9aec";
export var cloud = "DropDownMenu-module--cloud--69c12";
export var container = "DropDownMenu-module--container--021d2";
export var contentContainer = "DropDownMenu-module--contentContainer--53a16";
export var divider = "DropDownMenu-module--divider--05eb0";
export var entriesContainer = "DropDownMenu-module--entriesContainer--de267";
export var leftCloudContainer = "DropDownMenu-module--leftCloudContainer--4fed3";
export var legalLink = "DropDownMenu-module--legalLink--c0ed7";
export var rightCloudContainer = "DropDownMenu-module--rightCloudContainer--241c6";
export var rightCloudElementsContainer = "DropDownMenu-module--rightCloudElementsContainer--acb95";